import Grid from "@material-ui/core/Grid";
import { StyleRulesCallback, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";

const styles: StyleRulesCallback = ({ spacing }: Theme) => ({
  container: {
    "& > div": {
      margin: `${spacing.unit}px`
    },
    "& > div:last-child": {
      paddingRight: spacing.unit
    },
    overflowX: "auto"
  }
});

export const SliderBase: React.FC<WithStyles<typeof styles>> = ({ classes, children }) => (
  <Grid container={true} wrap="nowrap" classes={classes}>
    {children}
  </Grid>
);

export const SliderMobile = withStyles(styles)(SliderBase);
